import { Color, PaletteMode, PaletteOptions, Theme } from '@mui/material';

import {
  EAircraftStatus,
  EMaoMaintenanceBadge,
  ENOPOrganType,
  ESeverity,
} from '#shared';

export type TGetPaletteOptions = {
  mode: PaletteMode;
  background: string;
  primary: string;
  grey: Color;
  blue: Color;
  mapBlue: Color;
  green: Color;
  violet: Color;
  orange: Color;
  mint: Color;
  yellow: Color;
};
export const getPalette = ({
  mode,
  background,
  primary,
  grey,
  blue,
  mapBlue,
  green,
  violet,
  orange,
  mint,
  yellow,
}: TGetPaletteOptions): PaletteOptions => ({
  mode,
  background: {
    default: background,
  },
  primary: {
    main: primary,
  },
  grey,
  blue,
  mapBlue,
  green,
  violet,
  orange,
  mint,
  yellow,
});

export const getOpacityHex = (opacity: number): string =>
  Math.min(Math.max(Math.round(opacity * 255), 0), 255).toString(16);

const opacity = getOpacityHex(0.15);
export const getSeverityStyles = ({ palette }: Theme) => ({
  [`.severity-status-${ESeverity.CRITICAL}`]: {
    ['--primaryColor']: palette.severity.critical,
    ['--secondaryColor']: `${palette.severity.critical}${opacity}`,
  },
  [`.severity-status-${ESeverity.MAJOR}`]: {
    ['--primaryColor']: palette.severity.major,
    ['--secondaryColor']: `${palette.severity.major}${opacity}`,
  },
  [`.severity-status-${ESeverity.MINOR}`]: {
    ['--primaryColor']: palette.severity.minor,
    ['--secondaryColor']: `${palette.severity.minor}${opacity}`,
  },
  [`.severity-status-${ESeverity.LOW}`]: {
    ['--primaryColor']: palette.severity.low,
    ['--secondaryColor']: `${palette.severity.low}${opacity}`,
  },
});

export const getAircraftStatusStyles = ({ palette }: Theme) => ({
  [`.status-${EAircraftStatus.NotAvailable}`]: {
    ['--primaryColor']: palette.aircraftStatus.notAvailable,
    ['--secondaryColor']: `${palette.aircraftStatus.notAvailable}${opacity}`,
  },
  [`.aircraft-status-${EAircraftStatus.Available}`]: {
    ['--primaryColor']: palette.aircraftStatus.available,
    ['--secondaryColor']: `${palette.aircraftStatus.available}${opacity}`,
  },
  [`.aircraft-status-${EAircraftStatus.Maintenance}`]: {
    ['--primaryColor']: palette.aircraftStatus.maintenance,
    ['--secondaryColor']: `${palette.aircraftStatus.maintenance}${opacity}`,
    [`&.maintenance-type-${EMaoMaintenanceBadge.AOG}`]: {
      ['--primaryColor']: palette.aircraftStatus.aog,
      ['--secondaryColor']: `${palette.aircraftStatus.aog}${opacity}`,
    },
  },
});
export const getOrganStyles = ({ palette }: Theme) => ({
  [`.organ-type-${ENOPOrganType.Heart}`]: {
    ['--primaryColor']: palette.organ.heart,
    ['--secondaryColor']: `${palette.organ.heart}${opacity}`,
  },
  [`.organ-type-${ENOPOrganType.Liver}`]: {
    ['--primaryColor']: palette.organ.liver,
    ['--secondaryColor']: `${palette.organ.liver}${opacity}`,
  },
  [`.organ-type-${ENOPOrganType.Lungs}`]: {
    ['--primaryColor']: palette.organ.lungs,
    ['--secondaryColor']: `${palette.organ.lungs}${opacity}`,
  },
});
